import React, {useCallback, useEffect, useState} from 'react';
import {Box, LinearProgress, Paper, Typography} from '@mui/material';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ApiService from '../network/API';

// Сколько попыток отправки письменного ответа осталось на экзамене (каждый ответ проверяет AI и тратит одну попытку).
const ExamAttemptsMeter = ({attemptId, refreshKey}) => {
    const [attempt, setAttempt] = useState(null);

    const load = useCallback(() => {
        if (!attemptId) return;
        ApiService.getMyExamAttempt(attemptId).then(setAttempt).catch(() => {});
    }, [attemptId]);

    useEffect(() => {
        load();
        const timer = setInterval(load, 30000); // подхватываем увеличение лимита преподавателем
        return () => clearInterval(timer);
    }, [load, refreshKey]);

    if (!attempt || !attempt.llmLimit) return null;

    const limit = attempt.llmLimit;
    const used = Math.min(attempt.llmUsed, limit);
    const left = Math.max(0, limit - used);
    const color = left === 0 ? 'error' : left <= 2 ? 'warning' : 'primary';
    const word = (n) => (n % 10 === 1 && n % 100 !== 11 ? 'попытка' : [2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100) ? 'попытки' : 'попыток');

    return (
        <Paper variant="outlined" sx={{
            m: 1, mb: 0.5, px: 2, py: 1.25, borderRadius: 2.5, borderColor: `${color}.main`,
            background: (theme) => `linear-gradient(90deg, ${theme.palette[color].main}22, ${theme.palette[color].main}08)`,
        }}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap'}}>
                <Box sx={{width: 34, height: 34, borderRadius: '50%', display: 'grid', placeItems: 'center', flexShrink: 0,
                    bgcolor: (theme) => `${theme.palette[color].main}33`, color: `${color}.main`}}>
                    <AutoAwesomeOutlinedIcon fontSize="small"/>
                </Box>
                <Box sx={{flex: 1, minWidth: 180}}>
                    <Typography fontWeight={700} lineHeight={1.25}>
                        {left === 0 ? 'Попытки закончились' : `Осталось ${left} ${word(left)} из ${limit}`}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" lineHeight={1.3}>
                        {left === 0
                            ? 'Обратитесь к преподавателю, чтобы отправить ответ ещё раз.'
                            : 'Каждая отправка ответа проверяется AI и тратит одну попытку. Проверяется последний ответ.'}
                    </Typography>
                </Box>
                {limit <= 15 ? (
                    <Box sx={{display: 'flex', gap: 0.6}} aria-label={`использовано ${used} из ${limit}`}>
                        {Array.from({length: limit}).map((_, i) => (
                            <Box key={i} sx={{
                                width: 12, height: 12, borderRadius: '50%',
                                bgcolor: i < used ? 'action.disabledBackground' : `${color}.main`,
                                border: '1px solid', borderColor: i < used ? 'divider' : `${color}.main`,
                            }}/>
                        ))}
                    </Box>
                ) : (
                    <LinearProgress variant="determinate" color={color} value={(left / limit) * 100} sx={{width: 120, height: 8, borderRadius: 4}}/>
                )}
            </Box>
        </Paper>
    );
};

export default ExamAttemptsMeter;
